import translations, { Language, TranslationKeys } from "./translations";

export const setLanguage = (lang: Language) => {
  localStorage.setItem("language", lang); 
};

export const getLanguage = (): Language => {
  return (localStorage.getItem("language") as Language) || "en"; 
};

export const i18n = (key: TranslationKeys, params?: Record<string, string>): string => {
  const language = getLanguage(); 
  const translation = translations[language][key] || key;

  if (params) {
    return Object.keys(params).reduce(
      (str, paramKey) => str.replace(`{${paramKey}}`, params[paramKey]),
      translation
    );
  }

  return translation;
};
